import { User } from "@supabase/supabase-js";

interface ProjectDetails {
  authorityName: string;
  projectName: string;
  approvedDate: string;
  proposedDateOfCompletion: string;
  litigationsRelated: string;
  projectType: string;
}

interface Address {
  buildingName: string;
  streetName: string;
  locality: string;
  landmark: string;
  state: string;
  district: string;
  mandal: string;
  pincode: string;
}

interface DevelopmentWorkItem {
  commonAreasAndFacilities: string;
  available: string;
  percent: number;
  details: string;
}

interface TechnicalDetails {
  areaStatement: AreaStatement;
}

interface AreaStatement {
  netArea: number;
  vacantPlotArea: number;
  abuttingRoadWidth: number;
  hasOpenArea: boolean;
}

interface Project {
  projectName: string;
  developerName: string;
  uuid: string;
  alias: string;
  tags: string[];
  fileDetails: {
    projectDetails: ProjectDetails;
    address: Address;
    developmentWork: DevelopmentWorkItem[];
    buildings: Building[];
    projectAddress: ProjectAddress;
  };
  amenities: Amenities;
  location: { lat: number; lng: number };
  floorplanConfigurations: FloorplanConfiguration[];
  heroImageUrl?: string;
  buildingSummary: BuildingSummary;
  hasModelApartment: boolean;
  isPartner: boolean;
  totalUnits?: number;
  priceSummary?: {
    minPrice: number;
    medianPrice: number;
    mostCommonPrice: number;
  };
  review?: string;
  technicals?: TechnicalDetails;
  reviewPreview?: string;
}

interface ProjectAddress {
  village: string;
  locality: string;
  district: string;
  mandal: string;
  street: string;
}

interface BuildingInfo {
  projectName: string;
  towerName: string;
  numberOfBasement: string;
  numberOfPlinth: string;
  numberOfPodium: string;
  numberOfSlabs: string;
  numberOfStilts: string;
}

interface Floor {
  floorId: string;
  apartmentType: string;
  saleableArea: number;
  numberOfApartments: number;
  numberOfBookedApartments: number;
}

interface BuildingProgress {
  task: string;
  progress: number;
}
interface Building {
  buildingInfo: BuildingInfo;
  floors: Floor[];
  progress: BuildingProgress[];
}

interface Plot {
  areaOfPlot: number;
  plotNumber: string;
  numberOfPlots: number;
  numberOfPlotsBooked: number;
}

interface Amenities {
  totalArea: number;
  commonTypes: Record<string, boolean>;
  specialTypes: string[];
  features: string[];
}

interface FloorplanConfiguration {
  id: number;
  projectId: string;
  createdAt: string;
  name: string;
  area: number;
  facing?: string;
  documentId?: number;
  url?: string;
  rooms?: Record<string, any>;
  review?: Record<string, string[]>;
}

export enum SubscriptionPlan {
  Boss = "Boss",
  Goat = "Goat",
}
interface Subscription {
  id: number;
  userId: number;
  subscriptionStartDate: Date;
  subscriptionEndDate: Date;
  plan: SubscriptionPlan;
}

interface BBUser extends User {
  subscription?: Subscription;
}

export enum UserRoles {
  BhumibossAdmin = "bhumiboss_admin",
}

export enum OrderType {
  FtlReport = "FtlReport",
  BossPlan = "BossPlan",
  GoatPlan = "GoatPlan",
}

export enum PostLoginAction {
  PurchaseFTLReport = "PurchaseFTLReport",
  PurchaseBoss = "PurchaseBoss",
  PurchaseGoat = "PurchaseGoat",
}

interface BuildingSummary {
  buildings: number;
  apartments: number;
  maxFloors: number;
  minSize: number;
  maxSize: number;
  types: string[];
}


type Place = {
  location?: { lat: number; lng: number };
  name: string;
  externalId: string;
  address: string;
  rating: number;
  type: string;
  distance?: any;
  duration?: any;
};


export type {
  Amenities,
  Project,
  ProjectDetails,
  Address,
  DevelopmentWorkItem,
  BuildingInfo,
  Floor,
  Building,
  Plot,
  FloorplanConfiguration,
  Subscription,
  BBUser,
  BuildingSummary,
  Place,
  AreaStatement
};
